export enum KeyboardKey {
  TAB = "Tab",
  ESCAPE = "Escape",
  ENTER = "Enter",
}

export const NO_REACTION_KEYS = [
  KeyboardKey.TAB,
  KeyboardKey.ESCAPE,
  KeyboardKey.ENTER,
] as const;

